import type { MtbTrailDifficulty } from "~/lib/api";
import { MtbDifficultyIcon } from "~/components/ui/icons/difficulty-icons";
import { PillSelector } from "~/components/ui/pill-selector";

const DIFFICULTIES: { value: MtbTrailDifficulty; label: string }[] = [
  { value: "green", label: "Green" },
  { value: "blue", label: "Blue" },
  { value: "black", label: "Black" },
  { value: "double-black", label: "Double Black" },
  { value: "proline", label: "Proline" },
];

interface MtbTrailDifficultySelectorProps {
  value: MtbTrailDifficulty | null;
  onChange: (value: MtbTrailDifficulty | null) => void;
}

export function MtbTrailDifficultySelector({ value, onChange }: MtbTrailDifficultySelectorProps) {
  return (
    <PillSelector.Root value={value} onChange={onChange} label="Trail difficulty">
      {DIFFICULTIES.map(({ value: difficulty, label }) => (
        <PillSelector.Option key={difficulty} value={difficulty}>
          <MtbDifficultyIcon difficulty={difficulty} className="size-3.5" />
          {label}
        </PillSelector.Option>
      ))}
    </PillSelector.Root>
  );
}

export function MtbTrailDifficultyBadge({
  difficulty,
  outline,
}: {
  difficulty: MtbTrailDifficulty;
  outline?: boolean;
}) {
  const label = DIFFICULTIES.find((d) => d.value === difficulty)?.label;
  if (!label) return null;

  return (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <MtbDifficultyIcon difficulty={difficulty} outline={outline} className="size-4.5" />
      {label}
    </span>
  );
}
